<div class="h-40 relative header-wrapper" [ngClass]="{
    'max-h-72': !isMobile,
    'min-h-72': !isMobile,
    'max-h-56': isHome,
    'min-h-56': isHome,
    'max-h-44': (selectedCommune && isMobile) || isLanding,
    'min-h-44': (selectedCommune && isMobile) || isLanding,
    'max-h-52': elu && (elu.epci_id || elu.region_access) && insee && isMobile,
    'min-h-52': elu && (elu.epci_id || elu.region_access) && insee && isMobile,
    'max-h-96': elu && elu.epci_id && insee && !isMobile,
    'min-h-96': elu && elu.epci_id && insee && !isMobile,
    'max-h-80': elu && elu.region_access && insee && !isMobile,
    'min-h-80': elu && elu.region_access && insee && !isMobile
  }">
  <img *ngIf="!isMobile" src="../../../assets/illu_desktop.jpg" alt="paysage" class="fond" />
  <img *ngIf="isMobile" src="../../../assets/illu_phone.jpg" alt="paysage" class="fond" />
  <!-- <div class="region-access-wrapper" *ngIf="elu && elu.region_access && insee">
    <ion-button expand="block" fill="clear" class="linkBtn" (click)="goBackToRegion()">
      <ion-label>Revenir à la vision globale</ion-label>
    </ion-button>
  </div> -->
  <ion-header class="absolute top-0 flex flex-col h-full">
    <div class="epci-wrapper" *ngIf="elu && elu.epci_id && insee">
      <ion-button expand="block" fill="clear" class="linkBtn" (click)="goBackToEpci()">
        <ion-label>Revenir à la vision globale de l'EPCI</ion-label>
      </ion-button>
      <ion-select class="select" label="Changer de commune" cancelText="Annuler" [(ngModel)]="selectedCommuneEpci"
        (ionChange)="changeEpciCommune($event)" *ngIf="!isMobile">
        <ion-select-option *ngFor="let commune of epciInfos.cities" [value]="commune">{{ commune.name
          }}</ion-select-option>
      </ion-select>
    </div>

    <div class="departement-wrapper" *ngIf="elu && elu.departement_id && insee">
      <ion-button expand="block" fill="clear" class="linkBtn" (click)="goBackToDepartement()">
        <ion-label>Revenir à la vision globale du département</ion-label>
      </ion-button>
    </div>
    
    <div class="conseil-wrapper" *ngIf="elu && elu.pwa_conseil_id && insee">
      <ion-button expand="block" fill="clear" class="linkBtn" (click)="goBackToConseil()">
        <ion-label>Revenir au sélecteur de commune</ion-label>
      </ion-button>
    </div>
    <div class="region-access-wrapper" *ngIf="elu && elu.region_access && insee">
      <ion-button expand="block" fill="clear" class="linkBtn" (click)="goBackToRegion()">
        <ion-label>Revenir à la vision globale</ion-label>
      </ion-button>
    </div>
    <ion-toolbar [ngClass]="{
        'safe-top': !(elu && elu.region_access && insee),
        'safe-top-x2':
          (elu && elu.region_access && insee) || (elu && elu.epci_id && insee)
      }">
      <ion-buttons slot="start" *ngIf="!isHome && !(elu && elu.epci_id && !insee)">
        <!-- <ion-back-button default-href="#" text=""></ion-back-button> -->
        <ion-back-button default-href="" (click)="goBack()" text=""></ion-back-button>
        <!-- <ion-back-button default-href="" text=""></ion-back-button> -->
      </ion-buttons>
      <ion-buttons slot="end" *ngIf="!isPublic">
        <ion-button [routerLink]="['/profil']" *ngIf="elu && !elu.epci_id && !selectedCommune">
          <ion-icon slot="icon-only" name="person-circle"></ion-icon>
        </ion-button>
        <ion-button [routerLink]="['/commune/' + insee + '/profil']" *ngIf="
            ((elu && !elu.epci_id) || (elu && elu.epci_id && insee)) &&
            selectedCommune
          ">
          <ion-icon slot="icon-only" name="person-circle"></ion-icon>
        </ion-button>
        <ion-menu-button auto-hide="false"
          *ngIf="(elu && !elu.epci_id) || (elu && elu.epci_id && insee)"></ion-menu-button>
        <ion-button (click)="logout()" *ngIf="elu && elu.epci_id && !insee">
          <ion-icon slot="icon-only" name="log-out-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <div class="title-wrapper flex justify-center items-center flex-1 mb-6"
      *ngIf="!selectedCommune && !insee && elu && !elu.epci_id">
      <div class="w-full flex px-6" [ngClass]="{ 'justify-center': !isMobile }" *ngIf="!isHome">
        <h1 class="title">{{ title }}</h1>
        <div class="w-[30%]" *ngIf="isMobile"></div>
      </div>
      <div class="w-full flex justify-center px-6" *ngIf="isHome">
        <img [src]="logo" alt="logo" class="w-[70%] max-w-72" />
      </div>
    </div>
    <div class="title-wrapper flex justify-center items-center flex-1 mb-6" *ngIf="isLanding">
      <!-- <div
        class="w-full flex px-6"
        [ngClass]="{ 'justify-center': !isMobile }"
      >
        <h1 class="title">{{ title }}</h1>
        <div class="w-[30%]" *ngIf="isMobile"></div>
      </div> -->
      <div class="w-full flex justify-center px-6">
        <img [src]="logo" alt="logo" class="w-[70%] max-w-72" />
      </div>
    </div>
    <div class="title-wrapper commune flex justify-center items-center flex-1 mb-6" *ngIf="insee">
      <div class="w-full flex flex-col px-6 justify-center items-center" *ngIf="selectedCommune">
        <ion-icon name="location"></ion-icon>
        <h1 class="title">{{ selectedCommune.name }}</h1>
        <h2>Insee: {{ selectedCommune.insee }}</h2>
      </div>

      <div class="tabs" *ngIf="!isMobile && insee && !elu.pwa_conseil_id">
        <a [routerLink]="['/commune/' + insee]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <div class="flex w-full items-center gap-4">
            <ion-icon slot="start" name="home"></ion-icon>
            <span class="text-left">Accueil</span>
          </div>
        </a>
        <a [routerLink]="['/commune/' + insee + '/fibre']" routerLinkActive="active">
          <div class="flex w-full items-center gap-4">
            <ion-icon slot="start" name="git-network-outline"></ion-icon>
            <span class="text-left">La fibre dans ma commune</span>
          </div>
        </a>
        <a [routerLink]="['/commune/' + insee + '/app']" routerLinkActive="active" class="disabled">
          <div class="flex w-full items-center gap-4">
            <ion-icon slot="start" name="business-outline"></ion-icon>
            <span class="text-left">Mon application citoyenne </span>
          </div>
        </a>
      </div>
    </div>
    <div class="title-wrapper commune flex justify-center items-center flex-1 mb-6" *ngIf="selectedCommune && preview">
      <div class="w-full flex flex-col px-6 justify-center items-center" *ngIf="selectedCommune">
        <ion-icon name="location"></ion-icon>
        <h1 class="title">{{ selectedCommune.name }}</h1>
      </div>
    </div>
    <div class="title-wrapper commune flex justify-center items-center flex-1 mb-6"
      *ngIf="elu && elu.epci_id && !insee">
      <div class="w-full flex flex-col px-6 justify-center items-center">
        <h1 class="titleEpci" *ngIf="epciInfos && epciInfos.infos">
          Gestion de votre EPCI {{ epciInfos.infos.nom }}
        </h1>
      </div>
    </div>
    <div class="title-wrapper commune flex justify-center items-center flex-1 mb-6"
      *ngIf="elu && elu.departement_id && !insee">
      <div class="w-full flex flex-col px-6 justify-center items-center">
        <h1 class="titleEpci" *ngIf="departementInfos">
          Gestion de votre département {{departementInfos.departement_title}}
        </h1>
      </div>
    </div>
  </ion-header>
</div>